import clsx from 'clsx';

import { getGameScores } from '@/modules/rankings/ppr/helpers';
import { TournamentEventMatch } from '@/modules/rankings/ppr/types';

interface PWRScoresProps {
  match: TournamentEventMatch;
  swapped?: boolean;
}

export const PWRScores = ({ match, swapped }: PWRScoresProps) => {
  const validGames = getGameScores(match, !!swapped);

  return (
    <div className='hidden gap-x-6 px-4 sm:flex'>
      {validGames.map((game) => {
        const { label, teamOneScore, teamTwoScore } = game;
        const isEqual = teamOneScore === teamTwoScore;
        const isTeamOneWinning = teamOneScore > teamTwoScore;

        return (
          <div key={`pwr-scores-${label}`} className='flex flex-col text-center gap-1'>
            <p className='text-xs font-semibold text-gray-900'>{label}</p>
            <p
              className={clsx('text-lg', {
                'text-gray-900': isEqual,
                'text-[#5925DC] font-semibold': !isEqual && isTeamOneWinning,
                'text-gray-900 font-normal': !isEqual && !isTeamOneWinning,
              })}
            >
              {teamOneScore}
            </p>
            <p
              className={clsx('text-lg', {
                'text-gray-900': isEqual,
                'text-[#5925DC] font-semibold': !isEqual && !isTeamOneWinning,
                'text-gray-900 font-normal': !isEqual && isTeamOneWinning,
              })}
            >
              {teamTwoScore}
            </p>
          </div>
        );
      })}
    </div>
  );
};
